import InsurancePayorsAPI from '@api/insurancePayorsAPI'

import { initialQueryState } from '@models/apiBase'
import { ID } from '@models/base'
import { Option } from '@models/option'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

import TypeUtil from '@/utils/typeUtil'

type Props<IsMulti extends boolean> = Omit<AsyncPaginateSelectFieldProps<IsMulti>, 'onSearch'> & {
  insuranceId: ID | null
}

export const QueueNumberInsurancePayorSelectField = <IsMulti extends boolean = false>({
  insuranceId,
  isDisabled,
  ...props
}: Props<IsMulti>) => {
  const searchDebounce = async (keyword: string, page: number) => {
    if (!insuranceId) {
      return undefined
    }

    const { data } = await InsurancePayorsAPI.getOptionsForQueueNumber({
      ...initialQueryState,
      page,
      insurance_id: insuranceId,
      phrase: TypeUtil.isEmpty(keyword) ? null : keyword,
    })

    if (data) {
      return {
        ...data,
        nodes: data.nodes.map(
          (node) =>
            new Option({
              label: node.name,
              value: node.id,
              data: {
                call_center_number: node.call_center_number,
              },
            })
        ),
      }
    }
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      key={String(insuranceId)}
      isDisabled={isDisabled || !TypeUtil.isDefined(insuranceId)}
      onSearch={searchDebounce}
    />
  )
}

export default QueueNumberInsurancePayorSelectField
